import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "consult-request-page" }
const _hoisted_2 = { class: "console-page-head" }
const _hoisted_3 = { class: "console-page-copy" }
const _hoisted_4 = { class: "console-title" }
const _hoisted_5 = { class: "console-head-side" }
const _hoisted_6 = { class: "console-count" }
const _hoisted_7 = { class: "consult-request-body" }
const _hoisted_8 = { class: "content-card" }
const _hoisted_9 = { class: "consult-filter" }
const _hoisted_10 = { class: "consult-filter-search" }
const _hoisted_11 = {
  key: 0,
  class: "consult-filter-status"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 1,
  class: "consult-filter-kind"
}
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "row-num" }
const _hoisted_16 = {
  key: 0,
  class: "consult-state is-new"
}
const _hoisted_17 = { class: "consult-kind" }
const _hoisted_18 = { class: "consult-title-cell" }
const _hoisted_19 = { class: "consult-title-text" }
const _hoisted_20 = {
  key: 0,
  class: "consult-file"
}
const _hoisted_21 = { class: "consult-date" }
const _hoisted_22 = { class: "empty-message" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { class: "detail-info" }
const _hoisted_25 = { class: "detail-content-block" }
const _hoisted_26 = {
  key: 0,
  class: "detail-excel-block"
}
const _hoisted_27 = {
  key: 1,
  class: "detail-responses"
}
const _hoisted_28 = {
  key: 0,
  class: "response-excel"
}
const _hoisted_29 = {
  key: 2,
  class: "detail-reply-form"
}
const _hoisted_30 = { class: "reply-suggest" }
const _hoisted_31 = { class: "reply-suggest__head" }
const _hoisted_32 = { class: "reply-suggest__label" }
const _hoisted_33 = {
  key: 0,
  class: "reply-suggest__hint"
}
const _hoisted_34 = {
  key: 1,
  class: "reply-suggest__hint"
}
const _hoisted_35 = { class: "reply-excel-upload" }
const _hoisted_36 = { class: "reply-excel-control" }
const _hoisted_37 = { class: "reply-excel-name" }

import { computed, onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import { consultBoardApi } from '@/services/api'
import TablePagination from '@/components/common/TablePagination.vue'
import ConsultNontaxAnalysisModal from '@/components/admin/ConsultNontaxAnalysisModal.vue'
import type {
  ConsultRequestDetailResponse,
  ConsultRequestListItem,
} from '@/types/consultBoard'


export default /*@__PURE__*/_defineComponent({
  __name: 'ConsultRequestManagePage',
  props: {
    lockedKind: {}
  },
  setup(__props: any) {

const props = __props

const lockedKind = computed(() => (props.lockedKind || '').trim())
const pageTitle = computed(() => (lockedKind.value ? '설명회신청관리' : '상담요청관리'))

// 설명회 신청처럼 답변이 필요 없는 접수성 분류인지 판별
const isApplicationKind = (item: { kind?: string | null; landingSlot?: string | null }) =>
  Boolean(item.landingSlot) || (item.kind || '').includes('설명회신청')

const headers = computed(() => {
  const columns = [
    { title: 'No', key: 'index', sortable: false, align: 'center' as const, width: '56px' },
    { title: '상태', key: 'status', sortable: false, width: '72px' },
    { title: '분류', key: 'kind', sortable: false, width: '180px' },
    { title: '제목', key: 'title', sortable: false },
    { title: '기관', key: 'orgName', sortable: false, width: '180px' },
    { title: '등록', key: 'createdAt', sortable: false, width: '140px' },
  ]
  if (!lockedKind.value) return columns
  return columns.filter((column) => column.key !== 'kind')
})

const statusOptions = [
  { label: '전체', value: '' },
  { label: '대기', value: 'WAIT' },
  { label: '완료', value: 'DONE' },
]

const replySuggestions = ref<string[]>([])
const aiSuggestLoading = ref(false)
const aiSuggestSource = ref<'ai' | 'fallback' | ''>('')
const aiSuggestHint = ref('')
let aiSuggestSeq = 0

const loading = ref(false)
const items = ref<ConsultRequestListItem[]>([])
const keyword = ref('')
const statusFilter = ref('')
const kindFilter = ref('')
const kindOptions = ref<string[]>([])
const pagination = ref({ page: 1, limit: 20, total: 0, totalPages: 1 })

const store = useStore()
const isSuperAdmin = computed(
  () => Number(store.getters.actualRoleLevel ?? store.getters.roleLevel ?? 0) >= 100,
)

const detailOpen = ref(false)
const detail = ref<ConsultRequestDetailResponse | null>(null)
const isDetailApplication = computed(() =>
  detail.value ? isApplicationKind(detail.value.request) : false,
)
const deletingRequest = ref(false)
const replyContent = ref('')
const replyExcelFile = ref<File | null>(null)
const replyExcelInput = ref<HTMLInputElement | null>(null)
const submittingReply = ref(false)
const downloadingId = ref<number | null>(null)
const downloadingResponseId = ref<number | null>(null)
const nontaxModalOpen = ref(false)

const formatDateTime = (value: string) => {
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return value
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`
}

const loadRequests = async (page = pagination.value.page) => {
  loading.value = true
  try {
    const res = await consultBoardApi.listRequests({
      page,
      limit: pagination.value.limit,
      keyword: keyword.value.trim(),
      status: statusFilter.value,
      kind: lockedKind.value || kindFilter.value,
    })
    items.value = res.data.data.items
    kindOptions.value = res.data.data.kinds || []
    pagination.value = res.data.data.pagination
  } catch (error) {
    console.error('상담요청 목록 로드 실패:', error)
    alert('상담요청 목록을 불러오지 못했습니다.')
  } finally {
    loading.value = false
  }
}

const onPageChange = () => {
  loadRequests(pagination.value.page)
}

const onLimitChange = () => {
  pagination.value.page = 1
  loadRequests(1)
}

const setStatus = (value: string) => {
  if (statusFilter.value === value) return
  statusFilter.value = value
  loadRequests(1)
}

const onKindChange = () => {
  pagination.value.page = 1
  loadRequests(1)
}

const onRowClick = (_event: Event, row: { item: ConsultRequestListItem }) => {
  openDetail(row.item.id)
}

const onClearSearch = () => {
  keyword.value = ''
  loadRequests(1)
}

const openDetail = async (id: number) => {
  try {
    const res = await consultBoardApi.getRequestDetail(id)
    detail.value = res.data.data
    replyContent.value = ''
    clearReplyExcel()
    detailOpen.value = true
    if (!isApplicationKind(detail.value.request)) {
      void loadAiSuggestions()
    }
  } catch (error) {
    console.error('상담요청 상세 로드 실패:', error)
    alert('상담요청 상세를 불러오지 못했습니다.')
  }
}

const deleteRequest = async () => {
  if (!detail.value || deletingRequest.value) return
  if (!isSuperAdmin.value) {
    alert('최고관리자만 삭제할 수 있습니다.')
    return
  }
  if (!confirm('이 상담요청을 삭제할까요? 삭제하면 목록에서 사라집니다.')) return

  deletingRequest.value = true
  try {
    await consultBoardApi.deleteRequest(detail.value.request.id)
    detailOpen.value = false
    detail.value = null
    await loadRequests()
  } catch (error: any) {
    const msg = error.response?.data?.message || '삭제에 실패했습니다.'
    alert(msg)
  } finally {
    deletingRequest.value = false
  }
}

const loadAiSuggestions = async (force = false) => {
  if (!detail.value) return
  if (aiSuggestLoading.value && !force) return

  const seq = ++aiSuggestSeq
  const requestId = detail.value.request.id
  aiSuggestLoading.value = true
  aiSuggestHint.value = ''
  if (force) replySuggestions.value = []

  try {
    const res = await consultBoardApi.suggestAiReplies(requestId)
    if (seq !== aiSuggestSeq) return
    const data = res.data.data as {
      suggestions: string[]
      source: 'ai' | 'fallback'
      message?: string | null
    }
    replySuggestions.value = data.suggestions || []
    aiSuggestSource.value = data.source
    aiSuggestHint.value =
      data.source === 'ai'
        ? '문의 내용을 분석한 AI 초안입니다. 클릭하면 입력란에 들어갑니다.'
        : data.message || '자동 초안입니다. OpenAI API 키를 설정하면 AI 추천이 활성화됩니다.'
  } catch (error) {
    if (seq !== aiSuggestSeq) return
    console.error('AI 답변 추천 실패:', error)
    replySuggestions.value = ['기능 오류 수정 완료입니다. 이용에 불편을 드려 죄송합니다.']
    aiSuggestSource.value = 'fallback'
    aiSuggestHint.value = 'AI 추천을 불러오지 못했습니다.'
  } finally {
    if (seq === aiSuggestSeq) aiSuggestLoading.value = false
  }
}

const openReplyExcelPicker = () => {
  replyExcelInput.value?.click()
}

const assignReplyExcel = (file: File | null) => {
  if (!file) {
    replyExcelFile.value = null
    return
  }
  if (!file.name.toLowerCase().endsWith('.xlsx')) {
    alert('Excel(.xlsx) 파일만 업로드할 수 있습니다.')
    return
  }
  if (file.size > 5 * 1024 * 1024) {
    alert('파일 크기는 5MB이하여야 합니다.')
    return
  }
  replyExcelFile.value = file
}

const onReplyExcelChange = (event: Event) => {
  const target = event.target as HTMLInputElement
  assignReplyExcel(target.files?.[0] || null)
}

const clearReplyExcel = () => {
  replyExcelFile.value = null
  if (replyExcelInput.value) {
    replyExcelInput.value.value = ''
  }
}

const submitReply = async () => {
  if (!detail.value || !replyContent.value.trim()) return

  submittingReply.value = true
  try {
    await consultBoardApi.createResponse(
      detail.value.request.id,
      replyContent.value.trim(),
      replyExcelFile.value,
    )
    alert('답변이 등록되었습니다.')
    await openDetail(detail.value.request.id)
    await loadRequests()
  } catch (error: any) {
    const msg = error.response?.data?.message || '답변 등록에 실패했습니다.'
    alert(msg)
  } finally {
    submittingReply.value = false
  }
}

const downloadExcel = async (item: { id: number; excelName?: string | null }) => {
  downloadingId.value = item.id
  try {
    await consultBoardApi.downloadExcel(item.id, item.excelName || `consult-${item.id}.xlsx`)
  } catch (error) {
    console.error('Excel 다운로드 실패:', error)
    alert('Excel 다운로드에 실패했습니다.')
  } finally {
    downloadingId.value = null
  }
}

const downloadResponseExcel = async (response: { id: number; excelName?: string | null }) => {
  if (!detail.value) return

  downloadingResponseId.value = response.id
  try {
    await consultBoardApi.downloadResponseExcel(
      detail.value.request.id,
      response.id,
      response.excelName || `consult-response-${response.id}.xlsx`,
    )
  } catch (error) {
    console.error('답변 Excel 다운로드 실패:', error)
    alert('Excel 다운로드에 실패했습니다.')
  } finally {
    downloadingResponseId.value = null
  }
}

onMounted(() => {
  loadRequests(1)
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString(pageTitle.value), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(pagination.value.total) + "건", 1),
        (!lockedKind.value)
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 0,
              variant: "flat",
              class: "btn-register",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (nontaxModalOpen.value = true))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  size: "16",
                  class: "mr-1"
                }, {
                  default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                    _createTextVNode("mdi-chart-bar", -1)
                  ]))]),
                  _: 1
                }),
                _cache[14] || (_cache[14] = _createTextVNode(" 임금개선 월별 분석 ", -1))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("label", _hoisted_10, [
            _createVNode(_component_v_icon, { size: "18" }, {
              default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                _createTextVNode("mdi-magnify", -1)
              ]))]),
              _: 1
            }),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((keyword).value = $event)),
              type: "text",
              placeholder: "제목, 기관명",
              onKeydown: _cache[2] || (_cache[2] = _withKeys(($event: any) => (loadRequests(1)), ["enter"]))
            }, null, 544), [
              [_vModelText, keyword.value]
            ]),
            (keyword.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "consult-filter-clear",
                  onClick: onClearSearch
                }, "지우기"))
              : _createCommentVNode("", true)
          ]),
          (!lockedKind.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(statusOptions, (opt) => {
                  return _createElementVNode("button", {
                    key: opt.value || 'all',
                    type: "button",
                    class: _normalizeClass({ active: statusFilter.value === opt.value }),
                    onClick: ($event: any) => (setStatus(opt.value))
                  }, _toDisplayString(opt.label), 11, _hoisted_12)
                }), 64))
              ]))
            : _createCommentVNode("", true),
          (!lockedKind.value)
            ? (_openBlock(), _createElementBlock("label", _hoisted_13, [
                _cache[17] || (_cache[17] = _createElementVNode("span", null, "분류", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((kindFilter).value = $event)),
                  onChange: onKindChange
                }, [
                  _cache[16] || (_cache[16] = _createElementVNode("option", { value: "" }, "전체", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(kindOptions.value, (kind) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: kind,
                      value: kind
                    }, _toDisplayString(kind), 9, _hoisted_14))
                  }), 128))
                ], 544), [
                  [_vModelSelect, kindFilter.value]
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_v_data_table, {
          headers: headers.value,
          items: items.value,
          loading: loading.value,
          "items-per-page": -1,
          hover: "",
          class: "consult-request-table",
          "onClick:row": onRowClick
        }, {
          "item.index": _withCtx(({ index }) => [
            _createElementVNode("span", _hoisted_15, _toDisplayString((pagination.value.page - 1) * pagination.value.limit + index + 1), 1)
          ]),
          "item.status": _withCtx(({ item }) => [
            (isApplicationKind(item))
              ? (_openBlock(), _createElementBlock("span", _hoisted_16, "접수"))
              : (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  class: _normalizeClass(["consult-state", item.status === 'DONE' ? 'is-done' : 'is-wait'])
                }, _toDisplayString(item.status === 'DONE' ? '완료' : '대기'), 3))
          ]),
          "item.kind": _withCtx(({ item }) => [
            _createElementVNode("span", _hoisted_17, _toDisplayString(item.kind || '일반상담'), 1)
          ]),
          "item.title": _withCtx(({ item }) => [
            _createElementVNode("span", _hoisted_18, [
              _createElementVNode("span", _hoisted_19, _toDisplayString(item.title), 1),
              (item.hasExcel)
                ? (_openBlock(), _createElementBlock("span", _hoisted_20, "파일"))
                : _createCommentVNode("", true)
            ])
          ]),
          "item.createdAt": _withCtx(({ item }) => [
            _createElementVNode("span", _hoisted_21, _toDisplayString(formatDateTime(item.createdAt)), 1)
          ]),
          "no-data": _withCtx(() => [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("p", null, _toDisplayString(lockedKind.value ? '신청이 없습니다.' : '상담요청이 없습니다.'), 1)
            ])
          ]),
          bottom: _withCtx(() => [
            _createVNode(TablePagination, {
              "current-page": pagination.value.page,
              "onUpdate:currentPage": [
                _cache[4] || (_cache[4] = ($event: any) => ((pagination.value.page) = $event)),
                onPageChange
              ],
              "items-per-page": pagination.value.limit,
              "onUpdate:itemsPerPage": [
                _cache[5] || (_cache[5] = ($event: any) => ((pagination.value.limit) = $event)),
                onLimitChange
              ],
              "total-count": pagination.value.total,
              "total-pages": pagination.value.totalPages
            }, null, 8, ["current-page", "items-per-page", "total-count", "total-pages"])
          ]),
          _: 1
        }, 8, ["headers", "items", "loading"])
      ])
    ]),
    _createVNode(_component_v_dialog, {
      modelValue: detailOpen.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((detailOpen).value = $event)),
      "max-width": "760",
      scrollable: ""
    }, {
      default: _withCtx(() => [
        (detail.value)
          ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "detail-dialog-title" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(lockedKind.value ? '설명회 신청 상세' : '상담요청 상세') + " ", 1),
                    (isDetailApplication.value)
                      ? (_openBlock(), _createBlock(_component_v_chip, {
                          key: 0,
                          color: "primary",
                          size: "small",
                          variant: "flat",
                          class: "ml-2"
                        }, {
                          default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                            _createTextVNode(" 접수 ", -1)
                          ]))]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_v_chip, {
                          key: 1,
                          color: detail.value.request.status === 'DONE' ? 'success' : 'warning',
                          size: "small",
                          variant: "flat",
                          class: "ml-2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(detail.value.request.status === 'DONE' ? '답변완료' : '답변대기'), 1)
                          ]),
                          _: 1
                        }, 8, ["color"])),
                    _createElementVNode("button", {
                      type: "button",
                      class: "detail-dialog-close",
                      disabled: submittingReply.value || deletingRequest.value,
                      "aria-label": "닫기",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (detailOpen.value = false))
                    }, [
                      _createVNode(_component_v_icon, { size: "18" }, {
                        default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                          _createTextVNode("mdi-close", -1)
                        ]))]),
                        _: 1
                      })
                    ], 8, _hoisted_23)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, { class: "detail-dialog-body" }, {
                  default: _withCtx(() => [
                    _createElementVNode("dl", _hoisted_24, [
                      _createElementVNode("div", null, [
                        _cache[20] || (_cache[20] = _createElementVNode("dt", null, "작성자 ID", -1)),
                        _createElementVNode("dd", null, _toDisplayString(detail.value.request.authorId), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _cache[21] || (_cache[21] = _createElementVNode("dt", null, "분류", -1)),
                        _createElementVNode("dd", null, _toDisplayString(detail.value.request.kind || '일반상담'), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _cache[22] || (_cache[22] = _createElementVNode("dt", null, "제목", -1)),
                        _createElementVNode("dd", null, _toDisplayString(detail.value.request.title), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _cache[23] || (_cache[23] = _createElementVNode("dt", null, "기관명", -1)),
                        _createElementVNode("dd", null, _toDisplayString(detail.value.request.orgName), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _cache[24] || (_cache[24] = _createElementVNode("dt", null, "기관기호", -1)),
                        _createElementVNode("dd", null, _toDisplayString(detail.value.request.orgCode || '—'), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _cache[25] || (_cache[25] = _createElementVNode("dt", null, "연락처", -1)),
                        _createElementVNode("dd", null, _toDisplayString(detail.value.request.contactPhone), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _cache[26] || (_cache[26] = _createElementVNode("dt", null, "이메일", -1)),
                        _createElementVNode("dd", null, _toDisplayString(detail.value.request.email || '—'), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _cache[27] || (_cache[27] = _createElementVNode("dt", null, "접속 IP", -1)),
                        _createElementVNode("dd", null, _toDisplayString(detail.value.request.clientIp || '—'), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _cache[28] || (_cache[28] = _createElementVNode("dt", null, "등록일", -1)),
                        _createElementVNode("dd", null, _toDisplayString(formatDateTime(detail.value.request.createdAt)), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _cache[29] || (_cache[29] = _createElementVNode("h3", null, "상담 내용", -1)),
                      _createElementVNode("p", null, _toDisplayString(detail.value.request.content), 1)
                    ]),
                    (detail.value.request.hasExcel)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                          _createElementVNode("span", null, _toDisplayString(detail.value.request.excelName), 1),
                          _createVNode(_component_v_btn, {
                            size: "small",
                            variant: "outlined",
                            color: "primary",
                            loading: downloadingId.value === detail.value.request.id,
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (downloadExcel(detail.value.request)))
                          }, {
                            default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                              _createTextVNode(" Excel 다운로드 ", -1)
                            ]))]),
                            _: 1
                          }, 8, ["loading"])
                        ]))
                      : _createCommentVNode("", true),
                    (detail.value.responses.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                          _cache[32] || (_cache[32] = _createElementVNode("h3", null, "등록된 답변", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.value.responses, (response) => {
                            return (_openBlock(), _createElementBlock("article", {
                              key: response.id,
                              class: "response-item"
                            }, [
                              _createElementVNode("header", null, [
                                _createElementVNode("strong", null, _toDisplayString(response.byName || '관리자'), 1),
                                _createElementVNode("span", null, _toDisplayString(formatDateTime(response.createdAt)), 1)
                              ]),
                              _createElementVNode("p", null, _toDisplayString(response.content), 1),
                              (response.hasExcel)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                    _createElementVNode("span", null, _toDisplayString(response.excelName), 1),
                                    _createVNode(_component_v_btn, {
                                      size: "x-small",
                                      variant: "outlined",
                                      color: "primary",
                                      loading: downloadingResponseId.value === response.id,
                                      onClick: ($event: any) => (downloadResponseExcel(response))
                                    }, {
                                      default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                                        _createTextVNode(" Excel 다운로드 ", -1)
                                      ]))]),
                                      _: 1
                                    }, 8, ["loading", "onClick"])
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (!isDetailApplication.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                          _cache[38] || (_cache[38] = _createElementVNode("h3", null, "답변 작성", -1)),
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                              _createElementVNode("span", _hoisted_32, _toDisplayString(aiSuggestSource.value === 'ai'
                      ? 'AI 답변 추천'
                      : aiSuggestLoading.value
                        ? 'AI 분석 중'
                        : '답변 추천'), 1),
                              _createVNode(_component_v_btn, {
                                size: "x-small",
                                variant: "outlined",
                                loading: aiSuggestLoading.value,
                                disabled: !detail.value,
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (loadAiSuggestions(true)))
                              }, {
                                default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                                  _createTextVNode(" 다시 생성 ", -1)
                                ]))]),
                                _: 1
                              }, 8, ["loading", "disabled"])
                            ]),
                            (aiSuggestHint.value)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_33, _toDisplayString(aiSuggestHint.value), 1))
                              : _createCommentVNode("", true),
                            (aiSuggestLoading.value && !replySuggestions.value.length)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_34, " 문의 내용을 분석해 답변 초안을 만드는 중입니다… "))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(replySuggestions.value, (item, index) => {
                              return (_openBlock(), _createBlock(_component_v_chip, {
                                key: index,
                                size: "small",
                                variant: "outlined",
                                class: "reply-suggest__chip",
                                onClick: ($event: any) => (replyContent.value = item)
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            }), 128))
                          ]),
                          _createVNode(_component_v_textarea, {
                            modelValue: replyContent.value,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((replyContent).value = $event)),
                            rows: "6",
                            variant: "outlined",
                            density: "comfortable",
                            "hide-details": "",
                            placeholder: "상담 답변 내용을 입력해 주세요."
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_35, [
                            _cache[36] || (_cache[36] = _createElementVNode("span", { class: "reply-excel-label" }, "Excel 첨부 (선택)", -1)),
                            _createElementVNode("div", _hoisted_36, [
                              _createElementVNode("input", {
                                ref_key: "replyExcelInput",
                                ref: replyExcelInput,
                                type: "file",
                                class: "reply-excel-input",
                                accept: ".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                                onChange: onReplyExcelChange
                              }, null, 544),
                              _createVNode(_component_v_btn, {
                                size: "small",
                                variant: "outlined",
                                onClick: openReplyExcelPicker
                              }, {
                                default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                                  _createTextVNode(" 파일 선택 ", -1)
                                ]))]),
                                _: 1
                              }),
                              _createElementVNode("span", _hoisted_37, _toDisplayString(replyExcelFile.value ? replyExcelFile.value.name : '선택된 파일 없음'), 1),
                              (replyExcelFile.value)
                                ? (_openBlock(), _createBlock(_component_v_btn, {
                                    key: 0,
                                    size: "small",
                                    variant: "text",
                                    onClick: clearReplyExcel
                                  }, {
                                    default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                                      _createTextVNode(" 취소 ", -1)
                                    ]))]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _cache[37] || (_cache[37] = _createElementVNode("p", { class: "reply-excel-hint" }, ".xlsx, 5MB이하 · 매크로 포함 파일 불가", -1))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, { class: "detail-dialog-actions" }, {
                  default: _withCtx(() => [
                    (isSuperAdmin.value)
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 0,
                          color: "error",
                          variant: "text",
                          loading: deletingRequest.value,
                          onClick: deleteRequest
                        }, {
                          default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                            _createTextVNode(" 삭제 ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["loading"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      variant: "text",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (detailOpen.value = false))
                    }, {
                      default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                        _createTextVNode("닫기", -1)
                      ]))]),
                      _: 1
                    }),
                    (!isDetailApplication.value)
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 1,
                          color: "primary",
                          variant: "flat",
                          loading: submittingReply.value,
                          disabled: !replyContent.value.trim(),
                          onClick: submitReply
                        }, {
                          default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                            _createTextVNode(" 답변 등록 ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["loading", "disabled"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(ConsultNontaxAnalysisModal, {
      modelValue: nontaxModalOpen.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((nontaxModalOpen).value = $event))
    }, null, 8, ["modelValue"])
  ]))
}
}

})